/**
 * Get file extension from MIME type or data URL
 */
export function getFileExtension(mimeType: string, dataUrl?: string): string {
  if (dataUrl?.startsWith('data:image/png')) return 'png';
  if (dataUrl?.startsWith('data:image/webp')) return 'webp';
  if (dataUrl?.startsWith('data:image/gif')) return 'gif';
  
  switch (mimeType) {
    case 'image/png':
      return 'png';
    case 'image/webp':
      return 'webp';
    case 'image/gif':
      return 'gif';
    case 'image/jpeg':
    case 'image/jpg':
    default:
      return 'jpg';
  }
}

/**
 * Get the display image URL for a recipe
 * Uses only the presigned imageUrl field
 */
export function getRecipeDisplayImageUrl(recipe: { id: string; imageUrl?: string | null }): string | undefined {
  return recipe.imageUrl ?? undefined;
}